import "./header.css";
const Header = () => {
  return (
    <div>
      <h2>Fake Shop</h2>
    </div>
  );
};

export default Header;
